<template>
  <div class="flex flex-column h-full p-20px">
    <div class="h-panel h-full flex flex-column">
      <Tabs class="px-20px" :datas="subjectType" v-model="selected"></Tabs>
      <div class="pt-16px pr-16px flex justify-end">
        <div class="h-input-group mr-16px" v-if="isFor">
          <span class="h-input-addon">币别</span>
          <Select class="min-w-120px" keyName="id" titleName="name" type="object" v-model="currency" :datas="currencyList" :deletable="false"/>
          <span class="h-input-addon" v-if="currency">汇率：{{ currency.exchangeRate }}</span>
        </div>
        <Checkbox v-if="isUnit" v-model="hideUni" class="mr-16px">隐藏数量</Checkbox>
        <Button @click="doUpload" icon="fa fa-upload" v-if="!beginCheck">
          导入
        </Button>
        <a v-if="currency" class="h-btn" :href="'/api/initial-balance/download/' + currency.id">
          <i class="fa fa-download"></i>
          导出
        </a>
        <Button @click="trialBalance" color="primary">试算平衡</Button>
      </div>
      <div class="flex-1 p-16px h-0px">
        <vxe-table :loading="loading" ref="xTable" :data="datas"
                   border
                   height="auto"
                   :row-config="{keyField:'treeId',height:30}"
                   :tree-config="{transform: true, expandAll:true,showIcon:false,rowField: 'treeId', parentField: 'parentTreeId'}">
          <vxe-column title="编码" field="subjectCode" tree-node :min-width="200" :max-width="250"/>
          <vxe-column title="名称" field="subjectName" :min-width="200">
            <template #default="{row}">
              <!-- jxd优化图标按钮 -->
              <span class="mr-8px">
                {{ row.subjectName }}
                <!-- currency.id!==0用于综合本币位下禁止 && beginCheck当不是启用期间，期初禁止添加删除 -->
                <Tooltip  v-if="row.auxiliaryDetailId>0 && row.leaf && currency.id!==0 && !beginCheck" content="删除辅助项期初">
                    <vxe-button icon="vxe-icon-delete" type="text" status="info" size="mini" v-if="row.auxiliaryDetailId>0 && row.leaf" @click="delAuxiliaryClick(row)">删除</vxe-button>
                </Tooltip>
                <Tooltip v-if="row.auxiliaryAccounting.length && currency && currency.id!==0 && row.auxiliaryDetailId ==='0' && !beginCheck" content="点击添加辅助项期初">
                  <vxe-button size="mini" @click="addAuxiliary(row)" status="info" type="text" icon="vxe-icon-add">添加</vxe-button>
                </Tooltip>
              </span>
            </template>
          </vxe-column>
          <vxe-column title="方向" field="balanceDirection" width="60" align="center"/>
          <amount-group-col :beginCheck="beginCheck" :type="selected" v-if="(isUnit || !this.isLocal) && !this.hideUni" :is-unit="isUnit" :is-for="isFor" :is-local="isLocal" :is-start-year="isStartYear" :currency-name="currencyName" :val-change="valChange"/>
          <amount-col :beginCheck="beginCheck" :type="selected" v-else :is-start-year="isStartYear" :currency-name="currencyName" :val-change="valChange"/>
        </vxe-table>
      </div>
    </div>
  </div>
</template>

<script>
import {mapGetters, mapState} from 'vuex';
import manba from 'manba';
import {layer} from "@layui/layer-vue";
import {h} from "vue";
import InitialImport from "@/views/setting/initial/InitialImport";
import Np from "number-precision";
import InitialTrial from "@/views/setting/initial/InitialTrial";
import setting from "@/api/setting";
import AmountCol from "@/views/setting/initial/AmountCol.vue";
import AmountGroupCol from "@/views/setting/initial/AmountGroupCol.vue";
import YearTotalCol from "@/views/setting/initial/YearTotalCol.vue";
import InitialAuxiliary from "@/views/setting/initial/InitialAuxiliary.vue";
import {pick} from "xe-utils";
import checkout from "@api/checkout";
import Decimal from 'decimal.js';


export default {
  name: "Initial",
  components: {YearTotalCol, AmountGroupCol, AmountCol},
  data() {
    return {
      datas: [],
      codeUsed: [],
      currencyList: [],
      selected: '资产',
      loading: false,
      hideUni: false,
      beginCheck: false,
      currency: null,
    };
  },
  computed: {
    ...mapState(['currentAccountSets', 'subjectType', 'currencyMap']),
    ...mapGetters(['localCurrency']),
    isUnit() {
      return this.datas.filter(value => value.unit).length > 0;
    },
    isStartYear() {
      return manba(this.currentAccountSets.enableDate).month() === 1;
    },
    currencyId() {
      return this.currency ? this.currency.id : this.localCurrency.id;
    },
    isFor() {
      return this.currencyList.length > 0;
    },
    isLocal() {
      return this.localCurrency.id === this.currencyId || this.currencyId === 0;
    },
    currencyName() {
      if (!this.currency) {
        return "";
      }
      return this.currency['name'];
    },
    exchangeRate() {
      return Number(this.currency.exchangeRate);
    }
  },
  watch: {
    selected() {
      this.loadCurrencyList();
      this.loadList();
    },
    currency() {
      this.loadList();
    }
  },
  methods: {
    //jxd监听页面器事件
    startViewListener(){
      window.addEventListener('popstate', this.handlePopstate);
    },
    //jxd通过监听页面，判断是否是凭证录入页面正在显示，如果是，则启用快捷键，如果不是则卸载
    handlePopstate (event) {
      // 处理路由变化逻辑
      if (event.target.location.hash !== "#Initial") {
        // console.log('其他页面')
      } else {
        //切换回来了，刷新一下
        this.loadList();
      }
    },
    valChange(row, field) {
      // console.log("row",row,field)
      row[field] = row[field] || 0;
      let widthFiled, calVal;
      switch (field) {
        case 'beginBalanceFor':
          row.beginBalanceFor = Np.round(row.beginBalanceFor, 2);
          calVal = Np.times(row.beginBalanceFor, this.exchangeRate);
          widthFiled = 'beginBalance';
          break
        case 'beginBalance':
          row.beginBalance = Np.round(row.beginBalance, 2);
          calVal = Np.divide(row.beginBalance, this.exchangeRate);
          widthFiled = 'beginBalanceFor';
          break
        case 'yearTotalDebitFor':
          row.yearTotalDebitFor = Np.round(row.yearTotalDebitFor, 2);
          calVal = Np.times(row.yearTotalDebitFor, this.exchangeRate);
          widthFiled = 'yearTotalDebit';
          break
        case 'yearTotalDebit':
          row.yearTotalDebit = Np.round(row.yearTotalDebit, 2);
          calVal = Np.divide(row.yearTotalDebit, this.exchangeRate);
          widthFiled = 'yearTotalDebitFor';
          break
        case 'yearTotalCreditFor':
          row.yearTotalCreditFor = Np.round(row.yearTotalCreditFor, 2);
          calVal = Np.times(row.yearTotalCreditFor, this.exchangeRate);
          widthFiled = 'yearTotalCredit';
          break
        case 'yearTotalCredit':
          row.yearTotalCredit = Np.round(row.yearTotalCredit, 2);
          calVal = Np.divide(row.yearTotalCredit, this.exchangeRate);
          widthFiled = 'yearTotalCreditFor';
          break
          //jxd 期初数量，借方累计数量，贷方累计数量，没有处理这里补足a
        case 'beginQuantity':
          row.beginQuantity = Np.round(row.beginQuantity, 6);
          widthFiled = 'beginQuantity';
          console.log(row.beginQuantity,widthFiled)
          break
        case 'yearTotalCreditQuantity':
          row.yearTotalCreditQuantity = Np.round(row.yearTotalCreditQuantity, 6);
          widthFiled = 'yearTotalCreditQuantity';
          break  
        case 'yearTotalDebitQuantity':
          row.yearTotalDebitQuantity = Np.round(row.yearTotalDebitQuantity, 6);
          widthFiled = 'yearTotalDebitQuantity';
          break
      }

      let changeRows = {
        [row.id]: row
      };

      if (row.parentTreeId !== '0') {
        this.calParent(row, field, changeRows)
        //下面判断，非数值的，保留6位	
        if (widthFiled) {
          if (!["beginQuantity", "yearTotalCreditQuantity", "yearTotalDebitQuantity"].includes(widthFiled)) {
            row[widthFiled] = Np.round(calVal, 2);
          } 
          this.calParent(row, widthFiled, changeRows);
        }
      } else {
        if (widthFiled) {
          if (!["beginQuantity", "yearTotalCreditQuantity", "yearTotalDebitQuantity"].includes(widthFiled)) {
            row[widthFiled] = Np.round(calVal, 2);
          }  
          this.calTotal(row)
        }
      }

      let updateRows = Object.values(changeRows).map(val => {
        let row = pick(val, ["id", 'currencyId', 'subjectId', 'auxiliaryDetailId', 'accountSetsId', "beginBalance", "beginBalanceFor", "endBalance", "endForBalance", "debitFor", "debit", "creditFor", "credit", "yearTotalDebitFor", "yearTotalDebit", "yearTotalCreditFor", "yearTotalCredit", "yearTotalFor", "yearTotal", "beginQuantity", "endQuantity", "creditQuantity", "debitQuantity", "yearTotalCreditQuantity", "yearTotalDebitQuantity", "yearTotalQuantity"])
        if (val.balanceDirection === '借') {
          row.endBalance = row.beginBalance + row.debit - row.credit;
          row.endBalanceFor = row.beginBalanceFor + row.debitFor - row.creditFor;
        } else {
          row.endBalance = row.beginBalance - row.debit + row.credit;
          row.endBalanceFor = row.beginBalanceFor - row.debitFor + row.creditFor;
        }

        if (val.debit) {
          row.yearTotalDebit += val.debit
        }
        if (val.debitFor) {
          row.yearTotalDebitFor += val.debitFor
        }
        if (val.credit) {
          row.yearTotalCredit += val.credit
        }
        if (val.creditFor) {
          row.yearTotalCreditFor = val.creditFor
        }
        if (val.debitQuantity) {
          row.yearTotalDebitQuantity += val.debitQuantity
        }
        if (val.creditQuantity) {
          row.yearTotalCreditQuantity += val.creditQuantity
        }
        return row;
      });
      console.log(this.selected)
      if(this.selected == "损益"){
        console.log("损益类净发生额")
        updateRows.forEach(item=>{ 
          item.yearTotalCfCredit = item.yearTotalCredit;
          item.yearTotalCfDebit = item.yearTotalDebit;
        })
      }
      setting.initialBalance.save(updateRows);
    },
    loadCurrencyList() {
      setting.initialBalance.currencyList(this.selected).then(({data}) => {
        if (data.length) {
          this.currencyList = [{id: 0, name: '综合本位币', exchangeRate: '1.0000'}, ...data]
        } else {
          this.currencyList = [];
        }
      })
    },
    loadList() {
      this.loading = true;
      setting.initialBalance.list({type: this.selected, currencyId: this.currencyId}).then(({data: {balances, codeUsed}}) => {
        this.datas = balances;
        this.codeUsed = codeUsed || [];
        this.$nextTick(() => {
          this.$refs.xTable.setAllTreeExpand(true);
        });
      }).finally(() => {
        this.loading = false;
      })
    },
    calTotal(row) {
      /**
       * 年初原币金额
       * 借方科目：年初数 = 期初数 + 本年累计贷方 - 本年累计借方
       * 贷方科目：年初数 = 期初数 + 本年累计借方 - 本年累计贷方
       */
      if (row.balanceDirection === '借') {
        row.yearTotal = Np.round(Np.plus(row.beginBalance, Np.minus(row.yearTotalCredit, row.yearTotalDebit)), 2);
        row.yearTotalFor = Np.round(Np.plus(row.beginBalanceFor, Np.minus(row.yearTotalCreditFor, row.yearTotalDebitFor)), 2);
        //jxd数量期初计算异常处理a
        row.yearTotalQuantity = Np.round(Np.plus(row.beginQuantity, Np.minus(row.yearTotalCreditQuantity, row.yearTotalDebitQuantity)), 6);
      } else {
        row.yearTotal = Np.round(Np.plus(row.beginBalance, Np.minus(row.yearTotalDebit, row.yearTotalCredit)), 2);
        row.yearTotalFor = Np.round(Np.plus(row.beginBalanceFor, Np.minus(row.yearTotalDebitFor, row.yearTotalCreditFor)), 2);
        //jxd数量期初计算异常处理a
        row.yearTotalQuantity = Np.round(Np.plus(row.beginQuantity, Np.minus(row.yearTotalDebitQuantity, row.yearTotalCreditQuantity)), 6);
      }
    },
    calParent(row, field, changeRows) {
      const parent = this.$refs.xTable.getRowById(row.parentTreeId);
      // parent[field] = parent.children.reduce((sum, it) =>{
      //   let amt = it[field];
      //   if (parent.balanceDirection!==it.balanceDirection && (field.startsWith("beginBalance") || field==='yearTotal'|| field==='beginQuantity')) {
      //     amt = -amt
      //   }
      //   return sum + amt;
      // } , 0)
       //更精准的小数位处理
       parent[field] = parent.children.reduce((sum, it) => {
        let amt = new Decimal(it[field]);
        if (parent.balanceDirection !== it.balanceDirection && 
            (field.startsWith("beginBalance") || field === 'yearTotal' || field === 'beginQuantity')) {
          amt = amt.negated();
        }
        return sum.plus(amt);
      }, new Decimal(0)).toNumber();
      this.calTotal(row);
      this.calTotal(parent);
      parent.currencyId = row.currencyId;
      changeRows[parent.id] = parent;
      if (parent.parentTreeId !== '0') {
        this.calParent(parent, field, changeRows);
      }
    },
    trialBalance() {
      layer.open({
        title: "期初试算结果",
        zIndex: 1000,
        area: ['900px', '300px'],
        content: h(InitialTrial)
      });
    },
    doUpload() {
      let layerId = layer.open({
        title: "财务期初余额导入",
        shadeClose: false,
        closeBtn: false,
        zIndex: 1000,
        area: ['500px', 'auto'],
        content: h(InitialImport, {
          onClose: () => {
            layer.close(layerId);
          },
          onSuccess: () => {
            this.loadList();
            layer.close(layerId);
          }
        })
      });
    },
    addAuxiliary(row) {
      let layerId = layer.open({
        title: row.subjectName + "辅助明细",
        shadeClose: false,
        closeBtn: false,
        zIndex: 1000,
        area: ['1000px', '600px'],
        content: h(InitialAuxiliary, {
          subject: row,
          currency: this.currency,
          onClose: () => {
            layer.close(layerId);
          },
          onSuccess: () => {
            layer.close(layerId);
            this.loadList();
          }
        })
      });
    },
    delAuxiliaryClick(row) {
      // console.log("删除啊", row)
      this.$Confirm("确认删除?").then(() => {
        setting.initialBalance.delete({subjectId:row.subjectId,auxiliaryDetailId:row.auxiliaryDetailId}).then(() => {
          this.loadList();
        })
      })
    }
  },
  created() {
    checkout.beginCheck().then(({data}) => {
      this.beginCheck = data;
    })
  },
  mounted() {
    //jxd启用监听
    this.startViewListener();
    this.currency = this.localCurrency;
    this.loadCurrencyList();
    this.loadList();
  },
  beforeUnmount() {
    // console.log('Component will be unmounted soon');
    // 在需要卸载事件监听器的时候调用下面的代码
    window.removeEventListener('popstate', this.handlePopstate);
  }
};
</script>
<style scoped lang="less">
:deep(.vxe-input.size--mini) {
  height: 20px;
  line-height: 20px;
}
</style>
